import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { styled } from "@mui/material/styles";
import { FieldArray, getIn } from "formik";

const IOSSwitch = Index.styled((props) => (
  <Index.Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 34,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 3,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#3c0000",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 14,
    height: 14,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

const roleData = [
  { role: "Media Planner" },
  { role: "Media Buyer" },
  { role: "Creative" },
  { role: "Client Servicing" },
  { role: "Billing/Booking" },
  { role: "Other" },
];
export default function AgencyManagement() {
  const { adminDetails } = PagesIndex.useSelector(
    (state) => state.AdminReducer
  );
  const [data, setData] = useState([]);
  const [id, setId] = useState("");
  const [selectuserData, setSelectuserData] = useState();
  const [loading, setLoading] = useState(true);
  const [activityLog, setActivityLog] = useState([]);
  const [activityLoading, setActivityLoading] = useState(true);
  const [filterLog, setFilterLog] = useState([]);
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [deleteButtonSpinner, setDeleteButtonSpinner] = useState(false);
  const [statusButtonSpinner, setStatusButtonSpinner] = useState(false);
  const [openLogModal, setOpenLogModal] = useState(false);
  const handleCloseLogModal = () => setOpenLogModal(false);
  const [searchValue, setSearchValue] = useState("");
  const [openStatusModal, setOpenStatusModal] = useState(false);

  const handleOpenLogModal = (id) => {
    setOpenLogModal(true);
    setActivityLoading(true);
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_CLIENT_AGENCY_ACTIVITY_LOG + "/" + id
    ).then((res) => {
      setActivityLoading(false);
      if (res.status === 200) {
        let data = res?.data?.activityLog?.filter(
          (data) =>
            data?.previousAgencyName !== data?.agencyName ||
            data?.previousStatus !== data?.currentStatus
        );
        setFilterLog(data);
        setActivityLog(res.data?.activityLog);
      }
    });
  };

  const formRef = useRef();
  const initialValues = {
    agencyName: id ? selectuserData?.agencyName : "",
    agencyDetails: id
      ? selectuserData?.agencyDetails || [
          {
            role: "",
            name: "",
            contact: "",
            email: "",
          },
        ]
      : [
          {
            role: "",
            name: "",
            contact: "",
            email: "",
          },
        ],
  };

  const [addOrEdit, setAddOrEdit] = useState("Add");
  const [filteredData, setFilteredData] = useState([]);
  // add user modal
  const [open, setOpen] = useState(false);
  // delete modal
  const [openDelete, setOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const handleOpen = (op, id, data) => {
    setOpen(true);
    setAddOrEdit(op);
    setId(id);
    setSelectuserData(data);
  };
  const handleClose = () => {
    formRef.current.resetForm();
    setOpen(false);
  };
  const handleOpenDelete = (id) => {
    setOpenDelete(true);
    setId(id);
  };
  const handleCloseDelete = () => {
    setId("");
    setOpenDelete(false);
  };

  const handleGetAgency = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_ALL_CLIENT_AGENCY).then(
      (res) => {
        setLoading(false);
        if (res.status === 200) {
          let data = res?.data?.sort((a, b) =>
            a?.agencyName?.localeCompare(b?.agencyName)
          );
          setData(data);
          setFilteredData(data);
        }
      }
    );
  };

  useEffect(() => {
    setLoading(true);
    handleGetAgency();
  }, []);

  const handleAddEditAgency = (values) => {
    setButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    if (id) {
      urlEncoded.append("id", id);
    }
    urlEncoded.append("agencyName", values?.agencyName);
    urlEncoded.append("agencyDetails", JSON.stringify(values?.agencyDetails));
    PagesIndex.apiPostHandler(PagesIndex.Api.ADD_EDIT_CLIENT_AGENCY, urlEncoded)
      .then((res) => {
        setButtonSpinner(false);
        if (res.status === 201 || res.status === 200) {
          handleClose();
          handleGetAgency();
          setSearchValue("");
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) => {
        PagesIndex.toasterError(err.response.message);
      });
  };

  const handleDeleteAgency = () => {
    setDeleteButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    PagesIndex.apiPostHandler(
      PagesIndex.Api.DELETE_CLIENT_AGENCY,
      urlEncoded
    ).then((res) => {
      setDeleteButtonSpinner(false);
      if (res.status === 200) {
        handleCloseDelete();
        handleGetAgency();
        PagesIndex.toasterSuccess(res?.message);
      } else {
        PagesIndex.toasterError(res?.message);
      }
    });
  };
  const requestSearch = (e) => {
    setSearchValue(e.target.value);
    let filteredData = data.filter((data) =>
      data?.agencyName
        ?.toLowerCase()
        .includes(e?.target?.value?.trim()?.toLowerCase())
    );
    setCurrentPage(1);
    setFilteredData(filteredData);
  };
  const handleOpenStatusModal = (id) => {
    setId(id);
    setOpenStatusModal(true);
  };
  const handleCloseStatusModal = () => {
    setId("");
    setOpenStatusModal(false);
  };

  const handleStatus = () => {
    setStatusButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    PagesIndex.apiPostHandler(
      PagesIndex.Api.ISACTIVE_CLIENT_AGENCY,
      urlEncoded
    ).then((res) => {
      setStatusButtonSpinner(false);
      if (res.status === 200) {
        handleCloseStatusModal();
        PagesIndex.toasterSuccess(res?.message);
        handleGetAgency();
      } else {
        PagesIndex.toasterError(res?.message);
      }
    });
  };

  const renderTableRows = (setFieldValue) => {
    return filteredData
      ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
      ?.map((data) => {
        return (
          <Index.TableRow
            sx={{
              "&:last-child td, &:last-child th": {
                border: 0,
              },
            }}
            key={data?._id}
          >
            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {" "}
                {data?.agencyName || "-"}
              </Index.Typography>
            </Index.TableCell>

            <Index.TableCell
              component="td"
              variant="td"
              className="table-td"
              align="right"
            >
              <Index.Typography className="admin-table-data-text">
                {" "}
                {data?.createdBy?.name || "-"}
              </Index.Typography>
            </Index.TableCell>

            <Index.TableCell
              component="td"
              variant="td"
              className="table-td"
              align="right"
            >
              <Index.Typography className="admin-table-data-text">
                {" "}
                {data?.updatedBy?.name || "-"}
              </Index.Typography>
            </Index.TableCell>

            {(adminDetails?.roleId?.permissions?.includes("agency_edit") ||
              adminDetails?.roleId?.permissions?.includes("agency_delete")) && (
              <Index.TableCell
                component="td"
                variant="td"
                align="right"
                className="table-td"
              >
                <Index.Box className="admin-switch-main">
                  <Index.FormControlLabel
                    control={<IOSSwitch sx={{ m: 1 }} />}
                    className="admin-switch-lable"
                    checked={data?.isActive}
                    onChange={() => {
                      handleOpenStatusModal(data?._id);
                    }}
                  />
                </Index.Box>
              </Index.TableCell>
            )}

            {(adminDetails?.roleId?.permissions?.includes("agency_edit") ||
              adminDetails?.roleId?.permissions?.includes("agency_log") ||
              adminDetails?.roleId?.permissions?.includes("agency_delete")) && (
              <Index.TableCell
                component="td"
                variant="td"
                align="right"
                className="table-td"
              >
                <Index.Box className="admin-table-data-btn-flex ">
                  {adminDetails?.roleId?.permissions?.includes(
                    "agency_edit"
                  ) && (
                    <Index.Tooltip
                      title="Edit"
                      arrow
                      placement="bottom"
                      className="admin-tooltip"
                    >
                      <Index.Button
                        className="admin-table-data-btn"
                        onClick={() => {
                          setId(data?._id);
                          setFieldValue("agencyName", data.agencyName);
                          handleOpen("Edit", data?._id, data);
                        }}
                      >
                        <img
                          src={PagesIndex.Svg.blueedit}
                          className="admin-icon"
                          alt="Edit"
                        ></img>
                      </Index.Button>
                    </Index.Tooltip>
                  )}

                  {adminDetails?.roleId?.permissions?.includes(
                    "agency_log"
                  ) && (
                    <Index.Tooltip
                      title="Log"
                      arrow
                      placement="bottom"
                      className="admin-tooltip"
                    >
                      <Index.Button
                        className="admin-table-data-btn"
                        onClick={() => handleOpenLogModal(data?._id)}
                      >
                        <img
                          src={PagesIndex.Svg.logicon}
                          className="admin-icon"
                          alt="Log"
                        ></img>
                      </Index.Button>
                    </Index.Tooltip>
                  )}

                  {adminDetails?.roleId?.permissions?.includes(
                    "agency_delete"
                  ) && (
                    <Index.Tooltip
                      title="Delete"
                      arrow
                      placement="bottom"
                      className="admin-tooltip"
                    >
                      <Index.Button
                        className="admin-table-data-btn"
                        onClick={() => handleOpenDelete(data?._id)}
                      >
                        <img
                          src={PagesIndex.Svg.trash}
                          className="admin-icon"
                          alt="Delete"
                        ></img>
                      </Index.Button>
                    </Index.Tooltip>
                  )}
                </Index.Box>
              </Index.TableCell>
            )}
          </Index.TableRow>
        );
      });
  };

  const renderContent = (setFieldValue) => {
    if (filteredData?.length) {
      return renderTableRows(setFieldValue);
    } else {
      return <PagesIndex.DataNotFound />;
    }
  };

  const renderActivityTableRows = () => {
    return activityLog
      .slice()
      .reverse()
      .map((data) => {
        let updatedInfo = "";

        if (
          data?.previousAgencyName !== data?.agencyName ||
          data?.previousStatus !== data?.currentStatus
        ) {
          if (data?.updatedBy?.name) {
            updatedInfo = `${data?.updatedBy?.name}-${
              data?.dateTime
                ? PagesIndex.moment(data?.dateTime).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )
                : "-"
            }`;
          } else {
            updatedInfo = "-";
          }
        }
        return (
          <Index.TableRow
            sx={{
              "&:last-child td, &:last-child th": {
                border: 0,
              },
            }}
            key={data?._id}
          >
            {updatedInfo !== "" && (
              <>
                <Index.TableCell
                  component="td"
                  variant="td"
                  scope="row"
                  className="table-td"
                >
                  <Index.Typography className="admin-table-data-text">
                    <Index.Tooltip
                      title={`${
                        data?.previousAgencyName !== data?.agencyName
                          ? `${
                              data?.updatedBy?.agencyName
                            } has updated Tag Name from ${
                              data?.previousAgencyName
                            } to ${data?.agencyName + " "}`
                          : ""
                      }`}
                      arrow
                      placement="top"
                      className="admin-tooltip"
                    >
                      {data?.previousAgencyName !== data?.agencyName && (
                        <span>
                          <span className="span-bold">
                            {data?.updatedBy?.name}
                          </span>{" "}
                          has updated agency from{" "}
                          <span className="span-bold">
                            {data?.previousAgencyName}
                          </span>{" "}
                          to{" "}
                          <span className="span-bold">
                            {data?.agencyName + " "}
                          </span>
                        </span>
                      )}
                    </Index.Tooltip>
                  </Index.Typography>

                  <Index.Typography className="admin-table-data-text">
                    <Index.Tooltip
                      title={`${
                        data?.previousStatus !== data?.currentStatus
                          ? `${
                              data?.updatedBy?.agencyName
                            } Status has been updated from ${
                              !data?.currentStatus ? "Active" : "Deactive"
                            } to ${
                              data?.currentStatus ? "Active" : "Deactive"
                            } `
                          : ""
                      }`}
                      arrow
                      placement="top"
                      className="admin-tooltip"
                    >
                      {data?.previousStatus !== data?.currentStatus && (
                        <span>
                          <span className="span-bold">
                            {data?.updatedBy?.agencyName}
                          </span>{" "}
                          Status has been updated from{" "}
                          <span className="span-bold">
                            {!data?.currentStatus ? "Active" : "Deactive"}
                          </span>{" "}
                          to&nbsp;
                          <span className="span-bold">
                            {data?.currentStatus ? "Active" : "Deactive"}
                          </span>
                        </span>
                      )}
                    </Index.Tooltip>
                  </Index.Typography>
                </Index.TableCell>

                <Index.TableCell
                  component="td"
                  variant="td"
                  className="table-td"
                >
                  {updatedInfo}
                </Index.TableCell>
              </>
            )}
          </Index.TableRow>
        );
      });
  };

  const renderActivityLogContent = () => {
    return (
      <>
        {!activityLoading &&
          activityLog?.length > 0 &&
          renderActivityTableRows()}
        {!activityLoading &&
          (!activityLog ||
            activityLog.length === 0 ||
            filterLog.length === 0) && <PagesIndex.DataNotFound />}
      </>
    );
  };

  return (
    <PagesIndex.Formik
      enableReinitialize
      onSubmit={handleAddEditAgency}
      initialValues={initialValues}
      validationSchema={PagesIndex.agencySchema}
      innerRef={formRef}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        setFieldValue,
      }) => (
        <>
          <Index.Box className="admin-dashboard-content admin-user-list-content">
            <Index.Box className="admin-user-list-flex admin-page-title-main">
              <Index.Typography
                className="admin-page-title admin-user-list-page-title"
                component="h2"
                variant="h2"
              >
                Agency List
              </Index.Typography>
              <Index.Box className="admin-userlist-btn-flex">
                <Index.Box className="admin-search-main">
                  <Index.Box className="admin-search-box">
                    <Index.Box className="admin-form-group">
                      <Index.TextField
                        fullWidth
                        id="fullWidth"
                        className="admin-form-control"
                        placeholder="Search"
                        value={searchValue}
                        onChange={requestSearch}
                      />
                      <img
                        src={PagesIndex.Svg.search}
                        className="admin-search-grey-img admin-icon"
                        alt="search"
                      ></img>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                {adminDetails?.roleId?.permissions?.includes("agency_add") && (
                  <Index.Box className="admin-userlist-inner-btn-flex">
                    <Index.Box className="admin-adduser-btn-main btn-main-primary">
                      <Index.Button
                        className="admin-adduser-btn btn-primary"
                        onClick={() => {
                          setId("");
                          handleOpen("Add");
                        }}
                      >
                        <img
                          src={PagesIndex.Svg.plus}
                          className="admin-plus-icon"
                          alt="plus"
                        />
                        <span>Add Agency</span>
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                )}
              </Index.Box>
            </Index.Box>

            <Index.Box className="common-card">
              <Index.Box
                className={`admin-category-table-main ${
                  loading ? "" : "page-table-main"
                }`}
              >
                <Index.TableContainer
                  component={Index.Paper}
                  className="table-container"
                >
                  {loading ? (
                    <PagesIndex.Loader />
                  ) : (
                    <Index.Table aria-label="simple table" className="table">
                      <Index.TableHead className="table-head">
                        <Index.TableRow className="table-row">
                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="30%"
                          >
                            Agency Name
                          </Index.TableCell>

                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="12%"
                            align="right"
                          >
                            Created By
                          </Index.TableCell>

                          <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="12%"
                            align="right"
                          >
                            Updated By
                          </Index.TableCell>

                          {(adminDetails?.roleId?.permissions?.includes(
                            "agency_edit"
                          ) ||
                            adminDetails?.roleId?.permissions?.includes(
                              "agency_delete"
                            )) && (
                            <Index.TableCell
                              component="th"
                              variant="th"
                              className="table-th"
                              width="6%"
                              align="right"
                            >
                              Status
                            </Index.TableCell>
                          )}

                          {(adminDetails?.roleId?.permissions?.includes(
                            "agency_edit"
                          ) ||
                            adminDetails?.roleId?.permissions?.includes(
                              "category_log"
                            ) ||
                            adminDetails?.roleId?.permissions?.includes(
                              "agency_delete"
                            )) && (
                            <Index.TableCell
                              component="th"
                              variant="th"
                              className="table-th"
                              width="4%"
                              align="right"
                            >
                              Action
                            </Index.TableCell>
                          )}
                        </Index.TableRow>
                      </Index.TableHead>
                      <Index.TableBody className="table-body">
                        {renderContent(setFieldValue)}
                      </Index.TableBody>
                    </Index.Table>
                  )}
                </Index.TableContainer>
              </Index.Box>
              <Index.Box className="admin-pagination-main">
                {filteredData?.length ? (
                  <Index.Pagination
                    page={currentPage}
                    count={Math.ceil(filteredData?.length / 10)}
                    onChange={(event, newPage) => setCurrentPage(newPage)}
                    variant="outlined"
                    shape="rounded"
                    className="admin-pagination"
                  />
                ) : (
                  ""
                )}
              </Index.Box>
            </Index.Box>
          </Index.Box>

          <Index.Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="admin-modal"
          >
            <form onSubmit={handleSubmit} noValidate="novalidate">
              <Index.Box
                sx={style}
                className="admin-add-agency-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {addOrEdit} Agency
                  </Index.Typography>
                  {/* <Index.Box className="modal-close-btn" onClick={handleClose}>
                    <img
                      src={PagesIndex.Svg.closeblack}
                      className="admin-modal-close-icon"
                      alt="Close"
                    />
                  </Index.Box> */}
                </Index.Box>
                <Index.Box
                  className="admin-modal-hgt-scroll cus-scrollbar"
                  id="scrollDiv"
                >
                  {/* <ScrollIntoView /> */}
                  <Index.Box className="admin-input-box admin-modal-input-box">
                    <Index.FormHelperText className="admin-form-lable">
                      Agency Name<span className="astrick-sing">*</span>
                    </Index.FormHelperText>
                    <Index.Box className="admin-form-group">
                      <Index.TextField
                        name="agencyName"
                        fullWidth
                        id="agencyName"
                        className="admin-form-control"
                        placeholder="Enter Agency Name"
                        onChange={handleChange}
                        value={values?.agencyName}
                        error={errors.agencyName && touched.agencyName}
                        inputProps={{ maxLength: 40 }}
                      />
                      {touched.agencyName && errors.agencyName && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.agencyName}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>
                  <FieldArray name="agencyDetails">
                    {({ push, remove }) => (
                      <>
                        <Index.Box
                          display="grid"
                          gridTemplateColumns="repeat(12, 1fr)"
                          columnGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                        >
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 3",
                              md: "span 3",
                              lg: "span 3",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="admin-input-box admin-add-event-input-box">
                              <Index.FormHelperText className="admin-form-lable">
                                Role
                              </Index.FormHelperText>
                            </Index.Box>
                          </Index.Box>

                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 3",
                              md: "span 3",
                              lg: "span 3",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="admin-input-box admin-add-event-input-box">
                              <Index.FormHelperText className="admin-form-lable">
                                Name
                              </Index.FormHelperText>
                            </Index.Box>
                          </Index.Box>

                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 2",
                              md: "span 2",
                              lg: "span 2",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="admin-input-box admin-add-event-input-box">
                              <Index.FormHelperText className="admin-form-lable">
                                Mobile Number
                              </Index.FormHelperText>
                            </Index.Box>
                          </Index.Box>

                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 4",
                              md: "span 4",
                              lg: "span 4",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="event-add-flex">
                              <Index.Box className="admin-input-box admin-add-event-input-box">
                                <Index.FormHelperText className="admin-form-lable">
                                  Email Id
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box
                          display="grid"
                          gridTemplateColumns="repeat(12, 1fr)"
                          gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                        >
                          {values?.agencyDetails?.map((data, index) => {
                            const Role = `agencyDetails[${index}].role`;
                            const touchedRole = getIn(touched, Role);
                            const errorRole = getIn(errors, Role);

                            const Name = `agencyDetails[${index}].name`;
                            const touchedName = getIn(touched, Name);
                            const errorName = getIn(errors, Name);
                            const AgencyContact = `agencyDetails[${index}].contact`;
                            const touchedcontact = getIn(
                              touched,
                              AgencyContact
                            );
                            const errorcontact = getIn(errors, AgencyContact);

                            const AgencyEmail = `agencyDetails[${index}].email`;
                            const touchedEmail = getIn(touched, AgencyEmail);
                            const errorEmail = getIn(errors, AgencyEmail);

                            return (
                              <React.Fragment key={data?._id}>
                                <Index.Box
                                  gridColumn={{
                                    xs: "span 12",
                                    sm: "span 3",
                                    md: "span 3",
                                    lg: "span 3",
                                  }}
                                  className="grid-column"
                                >
                                  <Index.Box className="admin-input-box admin-add-event-input-box">
                                    <Index.Box className="admin-dropdown-box">
                                      <Index.FormControl className="admin-form-control admin-drop-form-control">
                                        <Index.Select
                                          className="admin-dropdown-select admin-drop-select"
                                          name={Role}
                                          id={Role}
                                          value={data?.role}
                                          onChange={handleChange}
                                          displayEmpty
                                          inputProps={{
                                            "aria-label": "Without label",
                                          }}
                                          renderValue={
                                            data?.role
                                              ? undefined
                                              : () => "Select Role"
                                          }
                                        >
                                          {roleData?.map((data) => {
                                            return (
                                              <Index.MenuItem
                                                key={data?.role}
                                                value={data?.role}
                                                className="admin-drop-menuitem"
                                              >
                                                {data?.role}
                                              </Index.MenuItem>
                                            );
                                          })}
                                        </Index.Select>
                                      </Index.FormControl>
                                      <PagesIndex.FormHelperText className="admin-error-text">
                                        {errorRole && touchedRole
                                          ? errorRole
                                          : null}
                                      </PagesIndex.FormHelperText>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>

                                <Index.Box
                                  gridColumn={{
                                    xs: "span 12",
                                    sm: "span 3",
                                    md: "span 3",
                                    lg: "span 3",
                                  }}
                                  className="grid-column"
                                >
                                  <Index.Box className="admin-input-box admin-add-event-input-box">
                                    <Index.Box className="admin-form-group">
                                      <Index.TextField
                                        name={Name}
                                        value={data?.name}
                                        fullWidth
                                        id={Name}
                                        className="admin-form-control"
                                        placeholder="Enter Name"
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100 }}
                                      />
                                      <PagesIndex.FormHelperText className="admin-error-text">
                                        {errorName && touchedName
                                          ? errorName
                                          : null}
                                      </PagesIndex.FormHelperText>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>

                                <Index.Box
                                  gridColumn={{
                                    xs: "span 12",
                                    sm: "span 2",
                                    md: "span 2",
                                    lg: "span 2",
                                  }}
                                  className="grid-column"
                                >
                                  <Index.Box className="admin-input-box admin-add-event-input-box">
                                    <Index.Box className="admin-form-group">
                                      <Index.TextField
                                        name={AgencyContact}
                                        value={data?.contact}
                                        fullWidth
                                        id={AgencyContact}
                                        className="admin-form-control"
                                        placeholder="Enter Mobile Number"
                                        onChange={(e) => {
                                          const regex = /^[0-9]*$/;
                                          if (regex.test(e.target.value)) {
                                            setFieldValue(
                                              AgencyContact,
                                              e.target.value
                                            );
                                          }
                                        }}
                                        inputProps={{ maxLength: 10 }}
                                      />
                                      <PagesIndex.FormHelperText className="admin-error-text">
                                        {errorcontact && touchedcontact
                                          ? errorcontact
                                          : null}
                                      </PagesIndex.FormHelperText>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>

                                <Index.Box
                                  gridColumn={{
                                    xs: "span 12",
                                    sm: "span 4",
                                    md: "span 4",
                                    lg: "span 4",
                                  }}
                                  className="grid-column"
                                >
                                  <Index.Box className="event-add-flex">
                                    <Index.Box className="admin-input-box admin-add-event-input-box">
                                      <Index.Box className="admin-form-group">
                                        <Index.TextField
                                          name={AgencyEmail}
                                          value={data?.email}
                                          fullWidth
                                          id={AgencyEmail}
                                          className="admin-form-control"
                                          placeholder="Enter Email Id"
                                          onChange={handleChange}
                                          inputProps={{ maxLength: 100 }}
                                        />
                                        <PagesIndex.FormHelperText className="admin-error-text">
                                          {errorEmail && touchedEmail
                                            ? errorEmail
                                            : null}
                                        </PagesIndex.FormHelperText>
                                      </Index.Box>
                                    </Index.Box>
                                    <Index.Box className="admin-input-box admin-add-event-input-box add-row-input-box">
                                      <Index.Box className="btn-main-primary orange-btn-main add-row-flex">
                                        {index ===
                                        values?.agencyDetails?.length - 1 ? (
                                          <Index.Button
                                            className="orange-btn add-row-btn"
                                            onClick={() => {
                                              push({
                                                id:
                                                  values.agencyDetails[
                                                    values.agencyDetails
                                                      ?.length - 1
                                                  ]?.id + 1 || 0,
                                                name: "",
                                                contct: "",
                                                email: "",
                                              });
                                            }}
                                          >
                                            <img
                                              src={PagesIndex.Svg.plus}
                                              className="admin-incress-dicress-icon"
                                              alt="Save"
                                            />
                                          </Index.Button>
                                        ) : (
                                          ""
                                        )}
                                        {values?.agencyDetails?.length > 1 ? (
                                          <Index.Button
                                            className="btn-primary add-event-btn "
                                            onClick={() => remove(index)}
                                          >
                                            <img
                                              src={PagesIndex.Svg.deleteicon}
                                              className="admin-incress-dicress-icon"
                                              alt="Save"
                                            />
                                          </Index.Button>
                                        ) : (
                                          ""
                                        )}
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </React.Fragment>
                            );
                          })}
                        </Index.Box>
                      </>
                    )}
                  </FieldArray>
                </Index.Box>
                <Index.Box className="modal-footer">
                  <Index.Box className="admin-modal-user-btn-flex">
                    <Index.Box className="admin-discard-btn-main border-btn-main">
                      <Index.Button
                        className="admin-discard-user-btn border-btn"
                        onClick={handleClose}
                        disabled={buttonSpinner}
                      >
                        Discard
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="admin-save-btn-main btn-main-primary">
                      <Index.Button
                        className={`${
                          id ? "update-btn" : "save-btn"
                        } admin-save-user-btn btn-primary`}
                        type="submit"
                        disabled={buttonSpinner}
                      >
                        {buttonSpinner ? (
                          <PagesIndex.Spinner />
                        ) : (
                          <>
                            <img
                              src={PagesIndex.Svg.save}
                              className="admin-user-save-icon"
                              alt="Save"
                            />
                            <span>{id ? "Update" : "Add"}</span>
                          </>
                        )}
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </form>
          </Index.Modal>

          <Index.Modal
            open={openDelete}
            onClose={handleCloseDelete}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="admin-modal"
          >
            <Index.Box
              sx={style}
              className="admin-delete-modal-inner-main admin-modal-inner"
            >
              <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                <Index.Box className="admin-modal-circle-main">
                  <img
                    src={PagesIndex.Svg.closecircle}
                    className="admin-user-circle-img"
                    alt="Close"
                  />
                </Index.Box>
                <Index.Typography
                  className="admin-delete-modal-title"
                  component="h2"
                  variant="h2"
                >
                  Are you sure?
                </Index.Typography>
                <Index.Typography
                  className="admin-delete-modal-para admin-common-para"
                  component="p"
                  variant="p"
                >
                  Do you really want to delete this agency? This process cannot
                  be undone.
                </Index.Typography>
                <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
                  <Index.Button
                    className="admin-modal-cancel-btn border-btn"
                    onClick={handleCloseDelete}
                    disabled={deleteButtonSpinner}
                  >
                    Cancel
                  </Index.Button>
                  <Index.Button
                    className="delete-user admin-modal-delete-btn btn"
                    onClick={handleDeleteAgency}
                    disabled={deleteButtonSpinner}
                  >
                    {deleteButtonSpinner ? (
                      <PagesIndex.Spinner />
                    ) : (
                      <span>Delete</span>
                    )}
                  </Index.Button>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Modal>

          <Index.Modal
            open={openLogModal}
            onClose={handleCloseLogModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="admin-modal"
          >
            <Index.Box
              sx={style}
              className="admin-log-modal-inner-main admin-modal-inner"
            >
              <Index.Box className="admin-modal-header">
                <Index.Typography
                  id="modal-modal-title"
                  className="admin-modal-title"
                  variant="h6"
                  component="h2"
                >
                  {" "}
                  Activity Log
                </Index.Typography>
                <Index.Button
                  className="modal-close-btn"
                  onClick={handleCloseLogModal}
                >
                  <img
                    src={PagesIndex.Svg.closeblack}
                    className="admin-modal-close-icon"
                    alt="Close"
                  />
                </Index.Button>
              </Index.Box>
              <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                <Index.Box className="common-card">
                  <Index.Box className="page-table-main category-activity-table-main">
                    <Index.TableContainer
                      component={Index.Paper}
                      className="table-container"
                    >
                      {activityLoading ? (
                        <PagesIndex.Loader />
                      ) : (
                        <Index.Table
                          aria-label="simple table"
                          className="table"
                        >
                          <Index.TableHead className="table-head">
                            <Index.TableRow className="table-row">
                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="70%"
                              >
                                Activity Log
                              </Index.TableCell>

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="30%"
                              >
                                Updated Date & Time
                              </Index.TableCell>
                            </Index.TableRow>
                          </Index.TableHead>
                          <Index.TableBody className="table-body">
                            {renderActivityLogContent()}
                          </Index.TableBody>
                        </Index.Table>
                      )}
                    </Index.TableContainer>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Modal>
          <PagesIndex.ChangeStatusModal
            data={"agency"}
            statusButtonSpinner={statusButtonSpinner}
            openStatusModal={openStatusModal}
            handleCloseStatusModal={handleCloseStatusModal}
            handleChangeStatus={handleStatus}
          />
        </>
      )}
    </PagesIndex.Formik>
  );
}
